import type {
  IMPORT_STATE,
  ImportHistoryItemT,
  ImportRuleT,
  ZendeskInfo,
} from '@/features/Setting/Integrations/providers/types';
import { ZendeskImportTemplate } from '@/features/Setting/Integrations/providers/Zendesk/zendesk-import-template';
import { defaultAxios } from '@/services/index';
import { captureException } from '@/shared/lib/sentry';
import { getCurrWorkspaceAlias } from '@/utils/workspace';

import { processImportRuleParam } from '../util';

// 서버쪽 스키마 변경 필요
export type ZendeskWorkspaceRes = {
  alias: string;
  domain: string;
  import_state: IMPORT_STATE;
  history?: ImportHistoryItemT[];
  import_rule: ImportRuleT;
};

const zendeskService = {
  async createZendeskInfo(
    code: string,
    workspaceAlias: string,
    redirect_uri: string,
    subdomain: string,
  ): Promise<ZendeskInfo | false> {
    try {
      const res = await defaultAxios.post(
        `/workspaces/${workspaceAlias}/zendesk/authenticated`,
        { code, redirect_uri, subdomain },
      );
      return {
        ...res.data,
        workspace_id: workspaceAlias,
      };
    } catch (e) {
      captureException(e, {
        extra: {
          error: e,
          data: {
            code,
            workspaceAlias,
            redirect_uri,
            subdomain,
          },
        },
      });
      return false;
    }
  },
  async getZendeskInfo(
    workspace_alias: string,
  ): Promise<ZendeskInfo | false> {
    try {
      const res = await defaultAxios.get<ZendeskWorkspaceRes>(
        `/workspaces/${workspace_alias}/zendesk/`,
      );
      return {
        ...res.data,
        workspace_id: workspace_alias,
      };
    } catch (e) {
      return false;
    }
  },
  async importWorkspaceFeedback(
    workspaceAlias: string,
    startDate: string,
    endDate: string,
  ) {
    try {
      const res = await defaultAxios.post(
        `/workspaces/${workspaceAlias}/zendesk/import`,
        {
          start_date: startDate,
          end_date: endDate,
        },
      );
      return res.data;
    } catch (e) {
      return false;
    }
  },
  async deleteZendeskInfo(zendesk_alias: string) {
    try {
      const res = await defaultAxios.delete(`/zendesk/${zendesk_alias}`);
      return res.data;
    } catch (e) {
      return false;
    }
  },
  async updateZendeskImportOption(importRule: ImportRuleT) {
    try {
      const wa = getCurrWorkspaceAlias();
      const processedImportRule = processImportRuleParam(
        importRule,
        ZendeskImportTemplate,
      );
      const res = await defaultAxios.patch(
        `/workspaces/${wa}/zendesk/trigger`,
        processedImportRule,
      );
      return res.data;
    } catch (e) {
      return false;
    }
  },
};

export default zendeskService;
